export enum SocialMarketing {
  FACEBOOK = 1,
  GOOGLE_ADS = 2,
  TIKTOK = 3,
  LANDING_PAGE = 4,
  INSTAGRAM = 5
}

export enum SocialStatus {
  Pending = 1, //Chờ duyệt
  Approved = 2, //Đã duyệt
  Reject = 3, //Từ chối
  Block = 4, //Khóa
  PermanentlyBlock = 5, //Khóa vĩnh viễn
  WaitingBlock=10,
  ApproveLock=12,
  QAApprove=99
}

export enum SocialPage {
  Activated,
  InActivated
}

export enum FeeIncurred {
  Tax = 1,
  Agency = 2,
  Other = 3
}
export enum SocialOption {
  QA_Management = 1,
  Share_QA_BM = 2,
  AddGroup = 3,
  Share_QA_TKQC = 4,
  Other = 5
}

export type SocialStatusName = 'Pending' | 'Approved' | 'Reject' | 'Block' | 'PermanentlyBlock';

export type SocialPageStatusName = 'activated' | 'inactivated';
